/**
 * NK collection — scroll to hash-linked product card on load.
 */
(function () {
  'use strict';

  const url = new URL(window.location.href);
  if (!url.hash) return;

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    },
    { once: true }
  );
})();
